// extracted by mini-css-extract-plugin
module.exports = {"title":"NewsItem_title__13rI4"};